import { render } from "./AdicionarPlanoClinica.vue?vue&type=template&id=4a30c76a&scoped=true"
import script from "./AdicionarPlanoClinica.vue?vue&type=script&lang=js"
export * from "./AdicionarPlanoClinica.vue?vue&type=script&lang=js"

import "./AdicionarPlanoClinica.vue?vue&type=style&index=0&id=4a30c76a&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a30c76a"]])

export default __exports__